(function(){
const COLLECTIONS = {"shop": {"site": "shop", "prefix": "Shop_", "productIds": ["15956513489221", "15956516045125", "15956516012357", "15956515946821", "15956515914053", "15956515848517", "15956515782981", "15956515750213", "15956515651909", "15956515553605", "15956515520837", "15956515455301", "15956515422533", "15956515389765", "15956515356997", "15956515291461", "15956515258693", "15956515225925", "15956515193157", "15956515127621", "15956515094853", "15956515062085", "15956514996549", "15956514898245", "15956514799941", "15956514701637", "15956514603333", "15956514537797", "15956514472261", "15956514439493", "15956514406725", "15956514373957", "15956514341189", "15956514275653", "15956514242885", "15956514210117", "15956514177349", "15956514144581", "15956514079045", "15956514046277", "15956514013509", "15956513980741", "15956513915205", "15956513849669", "15956513784133", "15956513751365", "15956513653061", "15956513587525", "15956513521989", "15956513456453", "15956513423685", "15956513390917", "15956513325381", "15956513292613", "15956513259845", "15956513227077", "15956513194309", "15956513128773", "15956513096005", "15956513063237", "15956513030469", "15956512964933", "15956512932165", "15956512899397", "15956512866629", "15956512801093", "15956512735557", "15956512702789", "15956512670021", "15956512637253", "15956512604485", "15956512538949", "15956512506181", "15956512473413", "15956512440645", "15956512407877", "15956512342341", "15956512276805", "15956512244037", "15956512211269", "15956512178501", "15956512080197", "15956512047429", "15956512014661", "15956511981893", "15956511949125", "15956511883589", "15956511850821", "15956511818053", "15956511785285", "15956511719749", "15956511686981", "15956511654213", "15956511621445", "15956511588677", "15956511523141", "15956511490373", "15956511457605", "15956511359301", "15956511326533", "15956511293765", "15956511260997", "15956511195461", "15956511162693", "15956511129925", "15956511097157", "15956511031621", "15956510998853", "15956510933317", "15956510900549", "15956510867781", "15956510802245", "15956510769477", "15956510736709", "15956510703941", "15956510638405", "15956510605637", "15956510572869", "15956510507333", "15956510474565", "15956510409029", "15956510343493", "15956510310725", "15956510245189", "15956510212421", "15956510179653", "15956510114117", "15956510081349", "15956510015813", "15956509983045", "15956509950277", "15956509884741", "15956509851973", "15956509786437", "15956509753669", "15956509720901", "15956509688133", "15956509622597", "15956509589829", "15956509557061", "15956509524293", "15956509458757", "15956509425989", "15956509393221", "15956509360453", "15956509294917", "15956509262149", "15956509229381", "15956509196613", "15956509131077", "15956509098309", "15956509065541", "15956509032773", "15956509000005", "15956508934469", "15956508901701", "15956508868933", "15956508836165", "15956508770629", "15956508737861", "15956508705093", "15956508672325", "15956508606789", "15956508574021", "15956508541253"]}, "vempire": {"site": "vempire", "prefix": "Vempire_", "productIds": ["16107336368453", "16107337318725", "16107339055429", "16107338137925", "16107339972933", "16107339514181", "16107340366149", "16107340693829", "16107340529989", "16107341119813", "16107340955973", "16107341250885", "16107341578565", "16107341447493", "16107341807941", "16107341939013", "16107342594373", "16107342299461", "16107343118661", "16107342889285"]}};
function empireCore(config) {
  const allowed = new Set(config.productIds.map(String));
  const names = new Set(['ViewContent','AddToCart','InitiateCheckout','AddPaymentInfo','Purchase']);
  const id = value => String(value || '').split('/').pop();
  const cents = value => {
    if (value === null || value === undefined || value === '') throw Error('Missing amount');
    const n = Number(value);
    if (!Number.isFinite(n) || n < 0 || n > 1000000) throw Error('Invalid amount');
    return Math.round(n * 100);
  };
  function line(variant, quantity, money) {
    if (!variant || !variant.product) throw Error('Missing product');
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 1000) throw Error('Invalid quantity');
    return { product_id:id(variant.product.id), variant_id:id(variant.id), quantity,
      cents:cents(money.amount), currency:String(money.currencyCode || '') };
  }
  function checkoutLines(checkout) {
    const lines = (checkout.lineItems || []).map(x => line(x.variant, x.quantity, x.finalLinePrice));
    if (!lines.length) return [];
    if (lines.some(x => x.currency !== checkout.currencyCode)) throw Error('Currency mismatch');
    const sum = lines.reduce((n,x) => n+x.cents,0);
    const subtotal = cents(checkout.subtotalPrice.amount);
    if (checkout.subtotalPrice.currencyCode !== checkout.currencyCode || subtotal > sum) throw Error('Invalid subtotal');
    // Allocate any remaining order discount proportionally over ALL merchandise,
    // including products outside these two collections. Largest remainder keeps cents exact.
    if (sum && subtotal < sum) {
      const allocated = lines.map((x,index) => ({index, value:Math.floor(x.cents*subtotal/sum), remainder:(x.cents*subtotal)%sum}));
      let extra = subtotal-allocated.reduce((n,x) => n+x.value,0);
      allocated.sort((a,b) => b.remainder-a.remainder || a.index-b.index);
      for (const x of allocated) { if (extra > 0) { x.value++; extra--; } lines[x.index].cents=x.value; }
    }
    return lines;
  }
  function build(name, lines, rawId, timestamp, url) {
    if (!names.has(name) || !rawId) throw Error('Invalid event');
    const selected = lines.filter(x => allowed.has(String(x.product_id)));
    if (!selected.length) return null;
    for (const x of selected) {
      if (!/^\d+$/.test(x.variant_id) || !Number.isInteger(x.quantity) || x.quantity<1 || x.quantity>1000 ||
          !Number.isInteger(x.cents) || x.cents<0 || x.cents>100000000 || !/^[A-Z]{3}$/.test(x.currency)) throw Error('Invalid line');
    }
    const currency=selected[0].currency;
    if (selected.some(x=>x.currency!==currency)) throw Error('Mixed currency');
    const event_time=Math.floor(new Date(timestamp).getTime()/1000);
    if (!Number.isFinite(event_time)) throw Error('Invalid time');
    const total=selected.reduce((n,x)=>n+x.cents,0);
    return {site:config.site,event_name:name,event_id:config.site+':'+name+':'+String(rawId),event_time,
      event_source_url:url,items:selected,custom_data:{currency,value:total/100,content_type:'product',
        content_ids:[...new Set(selected.map(x=>x.variant_id))],
        contents:selected.map(x=>({id:x.variant_id,quantity:x.quantity,item_price:x.cents/x.quantity/100})),
        num_items:selected.reduce((n,x)=>n+x.quantity,0),content_category:config.site}};
  }
  return {id,cents,line,checkoutLines,build};
}
(function () {
  'use strict';
  if (window.__empireDirectCommerce) return;
  window.__empireDirectCommerce = true;
  const endpoint = 'https://script.google.com/macros/s/AKfycbxnOeA_wDomxXr3Zfpe4NqG5cJTwIQOYRWVRJCcw7MBWIWyY-OZQ2EMv-eQQL-yosat/exec';
  const cores = Object.values(COLLECTIONS).map(config => ({config, core:empireCore(config)}));
  const shape = cores[0].core;
  let externalHash = '';
  let identityPromise;
  function allowed() {
    try {
      const p = window.Shopify && window.Shopify.customerPrivacy;
      return Boolean(p && p.marketingAllowed() && p.analyticsProcessingAllowed() &&
        (typeof p.saleOfDataAllowed !== 'function' || p.saleOfDataAllowed()));
    } catch (_) { return false; }
  }
  function identity() {
    if (!allowed()) return Promise.resolve();
    if (identityPromise) return identityPromise;
    identityPromise = (async () => {
      let value;
      try { value = localStorage.getItem('empire_commerce_id'); } catch (_) {}
      if (!value) {
        value = crypto.randomUUID();
        try { localStorage.setItem('empire_commerce_id',value); } catch (_) {}
      }
      const bytes = await crypto.subtle.digest('SHA-256',new TextEncoder().encode(value));
      externalHash = Array.from(new Uint8Array(bytes),x=>x.toString(16).padStart(2,'0')).join('');
    })().catch(()=>{});
    return identityPromise;
  }
  function cookie(name) {
    const match = document.cookie.split(';').map(x=>x.trim()).find(x=>x.startsWith(name+'='));
    if (!match) return '';
    try { return decodeURIComponent(match.slice(name.length+1)); } catch (_) { return ''; }
  }
  function cartLines(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];
    return shape.checkoutLines({currencyCode:cart.currency,subtotalPrice:{amount:cart.total_price/100,currencyCode:cart.currency},
      lineItems:cart.items.map(x=>({quantity:x.quantity,variant:{id:x.variant_id,product:{id:x.product_id}},
        finalLinePrice:{amount:x.final_line_price/100,currencyCode:cart.currency}}))});
  }
  function linesFor(kind,data) {
    if (kind==='begin') return cartLines(data.cart);
    if (kind==='view') return [shape.line({id:data.variant_id,product:{id:data.product_id}},1,{amount:data.price,currencyCode:data.currency})];
    if (kind==='add') {
      const x=data.line;
      if (!x || !x.product_id || x.final_price === undefined) return [];
      // Each attached cart/add request adds exactly one unit, even when the response contains an accumulated quantity.
      return [shape.line({id:x.variant_id || x.id,product:{id:x.product_id}},1,{amount:x.final_price/100,currencyCode:data.currency})];
    }
    return [];
  }
  async function emit(kind,data) {
    try {
      if (!allowed() || !['view','add','begin'].includes(kind)) return;
      const lines=linesFor(kind,data || {});
      if (!lines.length) return;
      const type={view:'ViewContent',add:'AddToCart',begin:'InitiateCheckout'}[kind];
      const id=crypto.randomUUID(),timestamp=new Date().toISOString();
      const source=location.origin+location.pathname;
      const payloads=cores.map(({config,core})=>{
        const p=core.build(type,lines,id,timestamp,source);
        if(p){p.event_type=type;p.event_name=config.prefix+type;}
        return p;
      }).filter(Boolean);
      if (!payloads.length) return;
      if (!externalHash) await identity();
      if (!allowed()) return;
      const user={client_user_agent:navigator.userAgent};
      if (externalHash) user.external_id=[externalHash];
      for (const key of ['fbp','fbc']) {
        const value=cookie('_'+key);
        if (/^fb\.\d+\.\d+\.[\w.-]+$/.test(value)) user[key]=value;
      }
      if (!user.external_id && !user.fbp && !user.fbc) return;
      for (const p of payloads) {
        p.user_data=user;p.marketing_allowed=true;
        try {
          if (typeof window.fbq === 'function') {
            window.fbq('trackCustom',p.event_name,p.custom_data,{eventID:p.event_id});
          }
        } catch (_) {}
        const body=JSON.stringify(p);
        // Beacon/keepalive starts transport without waiting for Google or delaying checkout.
        let queued=false;
        try { queued=Boolean(navigator.sendBeacon && navigator.sendBeacon(endpoint,new Blob([body],{type:'text/plain;charset=UTF-8'}))); } catch (_) {}
        if (!queued) fetch(endpoint,{method:'POST',mode:'no-cors',headers:{'Content-Type':'text/plain;charset=UTF-8'},body,keepalive:true}).catch(()=>{});
      }
    } catch (_) {}
  }
  const queue=window.EmpireCommerceQueue || [];
  window.EmpireCommerceQueue=[];
  window.EmpireCommerceEmit=emit;
  identity();
  document.addEventListener('visitorConsentCollected',()=>{
    if (allowed()) identity();
    else { externalHash='';identityPromise=undefined;try{localStorage.removeItem('empire_commerce_id');}catch(_){} }
  });
  queue.forEach(entry=>emit(entry.kind,entry.data));
})();

})();
